import { useTranslation } from "react-i18next";
import Modal from "../Modal";
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputRightElement
} from "@chakra-ui/react";
import { useState } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { passwordRegex } from "../../utils/security";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useUserContext } from "../../utils/userContext";

interface NewResetModalProps {
    isOpen: boolean;
    onClose: () => void;
}

type Passwords = {
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
}


const ResetPasswordModal = (props: NewResetModalProps) => {
    const { t } = useTranslation("translations");
    const { reloadData } = useUserContext();

    const [show, setShow] = useState<Boolean>(false)
    const [show1, setShow1] = useState<Boolean>(false);
    const [show2, setShow2] = useState<Boolean>(false);
    const [password, setPasswords] = useState<Passwords>({ currentPassword: "", newPassword: "", confirmPassword: "" });

    const changePassword = async () => {
        if(!passwordRegex.test(password.newPassword) || !passwordRegex.test(password.confirmPassword)) {
            toast.error(t("PASSWORD_DOESNT_MATCH_REGEX"), { position: toast.POSITION.BOTTOM_RIGHT });
        } else if (password.newPassword === password.confirmPassword) {
            try {
                await getAxiosInstance().post("/Password/ChangePassword", {
                    oldPassword: password.currentPassword,
                    newPassword: password.newPassword
                });

                toast.success(t("NEW_PASSWORD_SET"), { position: toast.POSITION.BOTTOM_RIGHT })
                reloadData();
                props.onClose();
            } catch (error) {
                toast.error(t("PROBLEM_SETTING_THE_NEW_PASSWORD"), { position: toast.POSITION.BOTTOM_RIGHT });
            }
        } else {
            toast.error(t("NEW_PASSWORD_AND_NEW_PASSWORD_CONFIRMATION_MISMATCH"), { position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    return (
        <>
            <Modal
                header={t("SET_PASSWORD_MODAL")}
                isOpen={props.isOpen}
                onClose={() => alert(t("CANT_CLOSE_RESET_PASSWORD_MODAL_WARNING"))}
                secondaryActionName={t("Save")}
                secondaryActionEnabled={true}
                secondaryAction={() => { changePassword() }}
            >
                <FormControl paddingBottom={4}>
                    <FormLabel>{t("Current Password")}</FormLabel>
                    <InputGroup size='md'>
                        <Input
                            isRequired
                            pr='4.5rem'
                            type={show ? 'text' : 'password'}
                            placeholder={t("Current Password")}
                            onChange={(e) => { setPasswords({ ...password, currentPassword: e.target.value }) }}
                        />
                        <InputRightElement width='4.5rem'>
                            <Button h='1.75rem' size='sm' onClick={() => setShow(!show)}>
                                {show ? <ViewOffIcon color="teal.500"/> : <ViewIcon color="teal.500"/>}
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </FormControl>

                <FormControl paddingBottom={4}>
                    <FormLabel>{t("New Password")}</FormLabel>
                    <InputGroup size='md'>
                        <Input
                            isInvalid={password.newPassword.length > 0 &&
                                !passwordRegex.test(password.newPassword)
                            }
                            value={password.newPassword}
                            isRequired
                            errorBorderColor='red.300'
                            pr='4.5rem'
                            type={show1 ? 'text' : 'password'}
                            placeholder={t("New Password")}
                            onChange={(e) => { setPasswords({ ...password, newPassword: e.target.value }) }}
                        />
                        <InputRightElement width='4.5rem'>
                            <Button h='1.75rem' size='sm' onClick={() => setShow1(!show1)}>
                                {show1 ? <ViewOffIcon color="teal.500"/> : <ViewIcon color="teal.500"/>}
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </FormControl>

                <FormControl paddingBottom={4}>
                    <FormLabel>{t("Confirm New Password")}</FormLabel>
                    <InputGroup size='md'>
                        <Input
                            isInvalid={password.confirmPassword.length > 0 &&
                                !passwordRegex.test(password.confirmPassword)
                            }
                            isRequired
                            value={password.confirmPassword}
                            pr='4.5rem'
                            type={show2 ? 'text' : 'password'}
                            placeholder={t("Confirm New Password")}
                            onChange={(e) => { setPasswords({ ...password, confirmPassword: e.target.value }) }}
                        />
                        <InputRightElement width='4.5rem'>
                            <Button h='1.75rem' size='sm' onClick={() => setShow2(!show2)}>
                                {show2 ? <ViewOffIcon color="teal.500"/> : <ViewIcon color="teal.500"/>}
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </FormControl>
            </Modal>
        </>
    )
}

export default ResetPasswordModal;